// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-info-block[data-v-6a07a78d]{display:flex;align-items:center;font-size:.875rem;grid-gap:.5rem;gap:.5rem;color:#1c1d20;color:var(--c-main,#1c1d20);border-radius:.75rem;padding:.5rem;background:rgba(165,161,255,.1);background:var(--c-transp-04,rgba(165,161,255,.1))}.exc-info-block__icon[data-v-6a07a78d]{width:1.5rem;height:1.5rem;fill:currentColor;flex-shrink:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
